import React from 'react';
export function Footer() {
  return <footer className="py-12 border-t border-black/10 dark:border-white/10" data-id="element-99">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-100">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-101">
          <div className="text-sm text-black/60 dark:text-white/60" data-id="element-102">
            © 2025 caltalk. all rights reserved.
          </div>
          <div className="flex gap-8 text-sm" data-id="element-103">
            <a href="#about" className="text-black/60 dark:text-white/60 hover:text-mint-600 dark:hover:text-mint-400 transition-colors" data-id="element-104">
              about
            </a>
            <a href="#privacy" className="text-black/60 dark:text-white/60 hover:text-mint-600 dark:hover:text-mint-400 transition-colors" data-id="element-105">
              privacy
            </a>
            <a href="#terms" className="text-black/60 dark:text-white/60 hover:text-mint-600 dark:hover:text-mint-400 transition-colors" data-id="element-106">
              terms
            </a>
            <a href="#contact" className="text-black/60 dark:text-white/60 hover:text-mint-600 dark:hover:text-mint-400 transition-colors" data-id="element-107">
              contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}